<template>
  <v-layout row wrap class="mt-2 mb-2">

    <v-flex xs6 sm4 md3 lg2 class="mt-2 pr-2">
      <resource-weight-graph :active="active" :graphData="graphData"></resource-weight-graph>
    </v-flex>

    <v-flex xs12 sm8 md4 lg5 class="mt-2 pl-2">
      <v-card class="pl-2 pb-2">
        <v-layout row class="pb-2">
          <v-flex xs6 class="pa-1">
            <div class="title">{{$t('resources.weighting.resource_type')}}</div>
          </v-flex>
          <v-flex xs6 class="pa-1">
            <div class="title text-xs-center">{{$t('resources.weighting.percentage')}}</div>
          </v-flex>
        </v-layout>
        <v-layout row v-for="data in graphData" :key="data.resource">
          <v-flex xs1 class="pl-1" :style="{'background-color': data.colour}">
          </v-flex>
          <v-flex xs5 class="pt-1 pl-2">
            {{data.label}}
          </v-flex>
          <v-flex xs6 class="pa-1 text-xs-center">
            {{data.weight}}
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>

    <v-flex xs12 sm12 md5 lg5 class="mt-2 pl-3">
      <v-card class="pa-2">
        <div v-html="explanation"></div>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import colors from 'vuetify/es5/util/colors'
import ResourceWeightGraph from './ResourceWeightGraph'

const colours = [
  colors.deepPurple.accent2,
  colors.green.darken4,
  colors.deepOrange.accent3,
  colors.cyan.lighten1,
  colors.lightGreen.lighten3,
  colors.orange.darken1,
  colors.pink.darken2,
  colors.indigo.accent1,
  colors.lightGreen.accent1,
  colors.red.accent3
]
const defaultColour = colors.blueGrey.lighten4

export default {
  name: 'resource-weighting',
  props: {
    active: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      explanation: this.$t('resources.weighting.explanation').join(' ')
    }
  },
  computed: {
    ...mapState({
      weighting: state => state.resources.weighting
    }),
    weightTotal () {
      let total = this.weighting.reduce((total, resourceWeight) => total + resourceWeight.weight, 0)
      return total
    },
    graphData () {
      return this.weighting.map((resourceWeight, index) => {
        return {
          label: this.checkIdentifier(resourceWeight.resource),
          weight: (100 * resourceWeight.weight / this.weightTotal).toFixed(1),
          colour: (index < colours.length) ? colours[index] : defaultColour
        }
      })
    }
  },
  components: {
    ResourceWeightGraph
  },
  methods: {
    checkIdentifier (identifier) {
      if (this.$t(`resources.identifiers.${identifier}`).includes('resources.identifiers')) {
        return identifier
      } else {
        return this.$t(`resources.identifiers.${identifier}`)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/resources/ResourceWeighting.vue